import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EditIcon from "../../../../Assets/OptionsModel/edit.svg";
import DeleteIcon from "../../../../Assets/OptionsModel/Delete.svg";
import ViewIcon from "../../../../Assets/OptionsModel/View.svg";
import ExchangeIcon from "../../../../Assets/Exchange.svg";
import { setModal, setSelectedProduct } from '../../../../Features/inventoryManagementSlice';
import { showToast } from '../../../../Components/Toaster/Toaster';

function KebabMenu({ product, boxRef }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [visible, setVisible] = useState(false);

    const productKebabOpen = useSelector((state) => state.inventoryManagement.productKebab.kebabOpen);

    const handleViewProduct = () => {
        if(product.product.status === 'Draft') {
            showToast('Cannot open Draft product. Please make the product Active.', 'warning');
            return;
        }
        else {
            navigate(`product/${product.product.id}`);
        }
    }

    const handleEditProduct = () => {
        // if(product.product.status === 'Draft') {
        //     showToast('Cannot open Draft product. Please make the product Active.', 'warning');
        //     return;
        // }
        // else {
            navigate(`edit-product/${product.product.id}`);
        // }
    }

    function handleEditVariant() {
        dispatch(setSelectedProduct(product));
        dispatch(setModal('select-variant-to-edit'));
    }

    function UpdateProductSizeChart() {
        dispatch(setSelectedProduct(product));
        dispatch(setModal('update-size-chart'));
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        dispatch(setSelectedProduct(product));
        dispatch(setModal('delete-confirm'));
    }

    useEffect(() => {
        if(productKebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [productKebabOpen]);

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-44 top-6 right-12 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-md overflow-hidden`}>
            <button onClick={handleViewProduct} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={ViewIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>View</p>
            </button>

            <button onClick={handleEditProduct} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={EditIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit Product</p>
            </button>

            {
                product?.varients?.length > 0 &&
                <button onClick={handleEditVariant} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                    <div className="size-[18px] flex items-center justify-center">
                        <img src={EditIcon} alt="" />
                    </div>

                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit a Variant</p>
                </button>
            }

            {
                product?.product?.SizeChartId && 
                <button onClick={UpdateProductSizeChart} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                    <div className="size-[18px] flex items-center justify-center">
                        <img src={ExchangeIcon} alt="" />
                    </div>

                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>Change size chart</p>
                </button>
            }

            {/* <button onClick={handleDelete} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={DeleteIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
            </button> */}
        </div>
    )
}

export default KebabMenu;
